import React from "react";
import { TECH } from "@/constants/testIds";

const TECHS = [
  "React", "Next.js", "TypeScript", "Node.js", "Python", "FastAPI",
  "Go", "Rust", "Swift", "Kotlin", "Flutter", "React Native",
  "PostgreSQL", "MongoDB", "Redis", "Kafka", "AWS", "GCP",
  "Kubernetes", "Docker", "Terraform", "OpenAI", "Anthropic", "Gemini",
  "LangChain", "Pinecone", "Stripe", "Supabase", "Vercel", "Cloudflare",
];

export default function TechStack() {
  // Duplicate for seamless marquee
  const list = [...TECHS, ...TECHS];

  return (
    <section
      data-testid={TECH.section}
      className="relative py-20 md:py-32 border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10 mb-10 md:mb-14">
        <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-[#0A84FF] mb-3 md:mb-4">
          The stack
        </p>
        <h2 className="font-display text-[10vw] sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[1.02] text-grad max-w-3xl">
          We pick the right tool. Always.
        </h2>
      </div>

      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black to-transparent z-10" />
        <div className="marquee-track flex gap-3 md:gap-4 whitespace-nowrap will-change-transform">
          {list.map((t, i) => (
            <span
              key={`${t}-${i}`}
              className="glass rounded-full px-4 md:px-6 py-2 md:py-3 text-xs sm:text-sm md:text-base font-medium text-white/80 inline-flex items-center gap-2 flex-none"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-[#0A84FF]" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
